module.exports = __webpack_public_path__ + "img/3.0d46e3f8.jpg";